import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { QueryParamsModel } from 'src/app/core/models/query-params.model';
import { IAuditUser } from 'src/app/core/interfaces/audit-user.interface';

import { ErrorService } from 'src/app/services/error.service';
import { environment } from 'src/environments/environment';
import * as AuditUSerActions from '../actions/audit-user-selector.actions';
import { AppState } from '../app.reducer';

@Injectable()
export class AuditUserEffects {
    constructor(
        public actions$: Actions,
        public http: HttpClient,
        private errorService: ErrorService,
        private store: Store<AppState>
    ) { }
    payloadReload;

    getAuditList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuditUSerActions.getAuditList),
            switchMap((payload) => {
                const query = { ...payload.payload, filters: JSON.stringify(payload.payload.filters) };
                this.store.dispatch(AuditUSerActions.auditUserLoading({ payload: { loading: true } }));
                this.payloadReload = payload.payload;
                const queryPayload = {
                    filters: query.filters,
                    sortOrder: query.sortOrder,
                    sortField: query.sortField,
                    pageNumber: query.pageNumber.toString(),
                    pageSize: query.pageSize.toString(),
                };
                return this.http
                    .get<{ data: IAuditUser[]; query: QueryParamsModel; totalCount: number }>(
                        environment.apiUrl + '/audit/users',
                        {
                            params: queryPayload,
                        }
                    )
                    .pipe(
                        switchMap((responseData) => {
                            this.store.dispatch(
                                AuditUSerActions.getAuditListSuccess({
                                    payload: {
                                        auditList: responseData.data,
                                        totalCount: +responseData.totalCount,
                                    },
                                })
                            );
                            return of(AuditUSerActions.auditUserLoading({ payload: { loading: false } }));
                        }),
                        catchError((error) => {
                            this.store.dispatch(
                                AuditUSerActions.auditUserFail({ payload: { error: this.errorService.mapError(error) } })
                            );
                            return of(AuditUSerActions.auditUserLoading({ payload: { loading: false } }));
                        })
                    );
            })
        )
    );

}
